module.exports = __webpack_public_path__ + "static/media/Business Card-02.09bab9ab.jpg";